export default "<footer></footer>\n";